import { DATE_RANGE_LABELS } from "../data/dateRanges";

export const checkStringIsDateRange = (string: string): string is DateRange => {
  return Object.keys(DATE_RANGE_LABELS).includes(string);
};
